<ng-container *ngFor="let video of videos">
  <sv-video-card></sv-video-card>
</ng-container>
